import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { RoomGuest } from "@lifeat/shared/data-models/Rooms/RoomGuest";
import UserAvatar from "../../../user/components/UserAvatar/UserAvatar";

const UserPresenceWrapper = styled.div`
    height: inherit;
    width: auto;
    max-width: 120px;
    overflow-x: scroll;
    cursor: pointer;
`;

interface UserRoomPresenceProps {
    readonly guest: RoomGuest;
}
function UserRoomPresence(props: UserRoomPresenceProps) {
    return (
        <UserPresenceWrapper
            data-tip={props.guest ? props.guest.userDisplayName : "Loading"}
            data-for={props.guest ? `user-avi-popover-${props.guest.userId}` : null}
        >
            <UserAvatar
                userDisplayName={props.guest.userDisplayName}
                userAviUrl={props.guest.userAviUrl}
                size={"small"}
            />
            <ReactTooltip id={`user-avi-popover-${props.guest.userId}`} />
        </UserPresenceWrapper>
    );
}

export default UserRoomPresence;
